'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MastheadExtension = undefined;

var _themeProvider = require('@spp/theme-provider');

var _MastheadExtension = require('./MastheadExtension');

var _MastheadExtension2 = _interopRequireDefault(_MastheadExtension);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.MastheadExtension = _MastheadExtension2.default;
exports.default = (0, _themeProvider.themer)('@spp/cn-masthead-extension')(_MastheadExtension2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/MastheadExtension/index.js
 ** module id = 606
 ** module chunks = 1
 **/